import { Box, Button, Link, Typography } from "@mui/material";

import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { GoogleLogin } from "@react-oauth/google";

interface SignupProps {
  handleGoogleSignIn: any;
  handleFailure: any;
  handleEmailSignIn: () => void;
  termsAndServiceLink: string;
  privacyPolicyLink: string;
}

const Signup = ({
  handleGoogleSignIn,
  handleFailure,
  handleEmailSignIn,
  termsAndServiceLink,
  privacyPolicyLink,
}: SignupProps) => {
  return (
    <Box
      width={"450px"}
      flexDirection={"column"}
      alignItems={"center"}
      justifyContent={"center"}
      display={"flex"}
      gap={2.5}
    >
      <Box>
        <Typography
          variant="h4"
          color="text.primary"
          align={"center"}
          fontWeight={600}
          letterSpacing={"0.25px"}
        >
          Welcome to Massic
        </Typography>
        <Typography
          variant="subtitle1"
          color="text.secondary"
          fontWeight={500}
          align={"center"}
          letterSpacing={"0.15px"}
        >
          Sign in to your account to continue.
        </Typography>
      </Box>
      <Box
        width={"100%"}
        padding={"24px 26px"}
        color={"text.secondary"}
        bgcolor={"white"}
        borderRadius={"8px"}
        display={"flex"}
        flexDirection={"column"}
        gap={3}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Box
          display={"flex"}
          justifyContent={"center"}
          flexDirection={"column"}
          gap={2}
          width={"100%"}
          alignItems={"center"}
        >
          {/* <Button
            fullWidth
            startIcon={
              <img
                src={"/icons/google.png"}
                alt="google"
                width={"24px"}
                height={"24px"}
              />
            }
            sx={{
              border: "1px solid #CFD8DC",
            }}
            onClick={handleGoogleSignIn}
            size="large"
          >
            <Typography
              color="text.secondary"
              variant="body2"
              fontWeight={500}
              letterSpacing={"0.4px"}
            >
              Continue with Google
            </Typography>
          </Button> */}
          <GoogleLogin onSuccess={handleGoogleSignIn} onError={handleFailure} />
          <Box
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            gap={2}
            width="100%"
          >
            <Box flex={1} height={"1px"} bgcolor={"#CFD8DC"} />
            <Typography color={"#64748B"} variant="caption">
              OR
            </Typography>
            <Box flex={1} height={"1px"} bgcolor={"#CFD8DC"} />
          </Box>
          <Button
            fullWidth
            onClick={handleEmailSignIn}
            startIcon={<EmailOutlinedIcon />}
            sx={{
              border: "1px solid #CFD8DC",
            }}
            size="large"
          >
            <Typography
              color="text.secondary"
              letterSpacing={"0.4px"}
              variant="body2"
              fontWeight={500}
            >
              Continue with Email
            </Typography>
          </Button>
        </Box>
        <Typography
          color={"#64748B"}
          fontWeight={500}
          fontSize={"10px"}
          align={"center"}
          sx={{
            "& a": {
              color: "#64748B",
            },
          }}
        >
          By continuing, you agree to our{" "}
          <Link href={termsAndServiceLink}>Terms of Service</Link> and{" "}
          <Link href={privacyPolicyLink}>Privacy Policy</Link>.
        </Typography>
      </Box>
    </Box>
  );
};

export default Signup;
